import { greenColors } from '@fiverr-private/theme/src/shared/themeVars';

export const MONEY_BACK_ICON =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/4011beb62973828e895fe8162424792d-1772630878104/money-back-guarantee-img.png';
export const FREELANCERS_BG =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/ee86a5ada6f7ab1c626e48091d54ca39-1773098956162/pro-banner-section-freelancers.png';
export const GRADIENT = `linear-gradient(180deg, ${greenColors.green_1000} -409.12%, ${greenColors.green_1200} 110.86%)`;
export const PRO_LINK_PATH = '/pro-solutions/expert-sourcing-services';
export const PRO_LINK_UTM_SOURCE = 'lohp_sourcing_banner';
